import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pinned-icon',
  standalone: true,
  templateUrl: './pinned-icon.component.html',
  styleUrls: ['./pinned-icon.component.scss']
})
export class PinnedIconComponent {
  @Input() width: number | string = 16;
  @Input() height: number | string = 16;
}
